import {
  type SelectedDataMetric, SelectedDataType,
} from '~/_shared/components/customizeMetrics/selectedDataMetric.type';
import { type SpreadsheetColumn } from '../../types/spreadsheetData/spreadsheetColumn';
import { MetricsDataAction } from './metrics.types';

export type SpreadsheetColumnGroupTotalMetricModel = {
  type: SelectedDataType.SpreadsheetColumn;
  spreadsheetColumn: SpreadsheetColumn;
  dataAction: MetricsDataAction.GROUP_TOTAL;
  secondarySpreadsheetColumn: SpreadsheetColumn;
};

export type SpreadsheetColumnValueMetricModel = {
  type: SelectedDataType.SpreadsheetColumn;
  spreadsheetColumn: SpreadsheetColumn;
  dataAction: MetricsDataAction.LOW_VALUE | MetricsDataAction.HIGH_VALUE | MetricsDataAction.SUM | MetricsDataAction.AVERAGE | MetricsDataAction.GROUP_COUNT;
};

export type SpreadsheetColumnMetricModel = SpreadsheetColumnGroupTotalMetricModel | SpreadsheetColumnValueMetricModel;

export const createSpreadsheetMetricFromSelectedData = (selectedData: SelectedDataMetric): SpreadsheetColumnMetricModel | null => {
  if (selectedData.type !== SelectedDataType.SpreadsheetColumn) {
    return null;
  }

  if (selectedData.dataAction === MetricsDataAction.GROUP_TOTAL) {
    return {
      type: SelectedDataType.SpreadsheetColumn,
      dataAction: MetricsDataAction.GROUP_TOTAL,
      spreadsheetColumn: selectedData.primarySpreadsheetColumn,
      secondarySpreadsheetColumn: selectedData.secondarySpreadsheetColumn,
    };
  }

  return {
    type: SelectedDataType.SpreadsheetColumn,
    dataAction: selectedData.dataAction,
    spreadsheetColumn: selectedData.primarySpreadsheetColumn,
  };
};

export const createSelectedDataFromSpreadsheetColumnMetric = (metric: SpreadsheetColumnMetricModel): SelectedDataMetric => {
  if (metric.dataAction === MetricsDataAction.GROUP_TOTAL) {
    return ({
      type: SelectedDataType.SpreadsheetColumn,
      dataAction: MetricsDataAction.GROUP_TOTAL,
      primarySpreadsheetColumn: metric.spreadsheetColumn,
      secondarySpreadsheetColumn: metric.secondarySpreadsheetColumn,
    });
  }
  return ({
    type: SelectedDataType.SpreadsheetColumn,
    dataAction: metric.dataAction,
    primarySpreadsheetColumn: metric.spreadsheetColumn,
  });
};
